import GoogleMapReact, { Props as GoogleMapProps } from 'google-map-react'
import React from 'react'

interface SimpleMapProps {
  apiKey: string
  defaultCenter: NonNullable<GoogleMapProps['defaultCenter']>
  defaultZoom: NonNullable<GoogleMapProps['defaultZoom']>
  options: NonNullable<GoogleMapProps['options']>
  onChange: NonNullable<GoogleMapProps['onChange']>
  onClick: NonNullable<GoogleMapProps['onClick']>
  onGoogleApiLoaded: NonNullable<GoogleMapProps['onGoogleApiLoaded']>
  onDrag: NonNullable<GoogleMapProps['onDrag']>
  children: GoogleMapProps['children']
}
export const SimpleMap = ({ children, apiKey, ...props }: SimpleMapProps) => {
  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: apiKey }}
      yesIWantToUseGoogleMapApiInternals={true}
      {...props}
    >
      {children}
    </GoogleMapReact>
  )
}
